export default "__VITE_ASSET__05fa95ee__"